/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../controls/Button';
import { INDUSTRIES } from '../../constants/global-constants';
import Dropdown from '../../controls/DropDown';

/**
 * Organisation Setup component for Account Activation.
 * @returns - Recat component for OrganisationSetup.
 */
export default function OrganisationSetupComponent(): ReactElement {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [industry, setIndustry] = useState('');
  const [zipCode, setZipCode] = useState('');
  /**
   * Handles the setupOrganisation action when the form is submitted.
   * @param  data - The form submit event.
   */
  const setupOrganisation = (data: any): void => {
    data.preventDefault();
    /**
     * Callback function.
     */
    const cb = (): void => {
      setLoading(false);
    };
    setLoading(true);
    cb();
    navigate('/auth/link-sent');
  };

  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="dark:bg-container-700 bg-white p-6 rounded w-full">
        <div className="text-xl dark:text-white text-black font-semibold flex items-center gap-2">
          Setup your Organization
        </div>
        <div className="text-gray-400 mt-1">Please enter org information to setup our account</div>
        <form className="mt-8 2xl:mt-12" action="post" onSubmit={setupOrganisation}>
          {/* <InputBox
            name="org-name"
            id="org-name"
            label="Organization name"
            textValue={name}
            setText={setName}
          />
          <InputBox
            name="org-url"
            id="org-url"
            actionElement={
              <div className="absolute right-2 bg-gray-800 flex items-center text-primary-200 top-2 bottom-2 text-xs px-2 rounded">
                .telosair.com
              </div>
            }
            label="Organization URL"
            textValue={url}
            setText={setUrl}
          /> */}
          <Dropdown
            label="Industry"
            name="Industry"
            options={INDUSTRIES.map((value) => ({ value }))}
            handleOptionsSelect={(e: any) => setIndustry(e.target.value)}
            field="value"
          />
          {/* <InputBox
            name="postal-code"
            id="postal-code"
            label="Zipcode"
            autoComplete="postal-code"
            textValue={zipCode}
            setText={setZipCode}
          /> */}
          <div className="mt-6 w-full">
            <Button
              onClick={() => navigate('/account-activation/device-setup')}
              isBlockButton
              buttonType="submit"
              loading={loading}
              theme="primary"
              size="sm"
              name="Continue to devices setup "
            />
          </div>
        </form>
      </div>
      <div className="flex justify-center items-center flex-row gap-3">
        <div className="font-medium text-gray-500">Trouble Activating?</div>
        <div className="w-40">
          <Button isBlockButton size="sm" theme="secondary-color" name="Contact Support" />
        </div>
      </div>
    </div>
  );
}
